import {
  INIT_REDUCER,
  CLEAR_ERRORS,
  CREATE_ERRORS,
  GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_REQUEST,
  DELETE_NO_VALIDATED_RC_SCANNED_DOCUMENT_REQUEST,
} from './types';

export const deleteNoValidatedScannedDocument = (payload) => ({
  type: DELETE_NO_VALIDATED_RC_SCANNED_DOCUMENT_REQUEST,
  payload,
});

export const getNoValidatedScannedDocuments = (payload) => ({
  type: GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_REQUEST,
  payload,
});

export const initReducer = () => ({
  type: INIT_REDUCER,
});

export const clearErrors = () => ({
  type: CLEAR_ERRORS,
});

export const createErrors = (payload) => ({
  type: CREATE_ERRORS,
  payload: payload,
});
